/**
 * Why the initial setup cannot take a person: each of department, Stelle and
 * canonical email that is missing. Empty when the setup takes the person.
 */ export function unsuppliedReasons(person) {
    return [
        ...person.department ? [] : [
            'missingDepartment'
        ],
        ...person.role ? [] : [
            'missingRole'
        ],
        ...person.email ? [] : [
            'missingEmail'
        ]
    ];
}

//# sourceMappingURL=data-sync-unsupplied.js.map